import React from 'react'
import Navbar from '../navbar/navbar'
import Project from '../projects/project'

const Projectpage = () => {
  return (
    <div>
      <Navbar/>
      <Project/>
    </div>
  )
}

export default Projectpage
